export const EXTERNAL_POLYGON_LAYERS_BEFORE_ID =
  'wd-inject-external-layers-below';
export const EXTERNAL_POINT_LAYERS_BEFORE_ID =
  'wd-inject-external-point-line-layers-below';
export const EXTERNAL_LINE_LAYERS_BEFORE_ID =
  'wd-inject-external-point-line-layers-below';
